import script from "./CreditorAccessBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreditorAccessBanner.vue?vue&type=script&setup=true&lang=ts"

import "./CreditorAccessBanner.vue?vue&type=style&index=0&id=e00fdba2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e00fdba2"]])

export default __exports__